<template>
  <div id="app">
    <transition :name="transitionName">
      <keep-alive>
        <router-view class="Router"></router-view>
      </keep-alive>
    </transition>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      transitionName: "slide-right"
    };
  },
  watch: {
    $route(to, from) {
      let routersArr =
        (sessionStorage.getItem("routers") &&
          sessionStorage.getItem("routers").split(",")) ||
        [];
      if (routersArr.length == 0) {
        routersArr.push(from.path);
        routersArr.push(to.path);
      } else {
        if (routersArr.indexOf(to.path) != -1) {
          this.transitionName = "slide-right";
          routersArr.splice(routersArr.indexOf(to.path) + 1, 100);
        } else {
          this.transitionName = "slide-left";
          routersArr.push(to.path);
        }
      }
      sessionStorage.setItem("routers", routersArr.join(","));
    }
  }
};
</script>

<style>
#app{
  height: 100%;
}

.router-view{
  width: 100%;
  height:100%;
  position: absolute;
  top: 0;
  bottom: 0;
  margin: 0 auto;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}

.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  height: 100%;
  will-change: transform;
  transition: all 400ms;
  position: absolute;
  backface-visibility: hidden;
  perspective: 1000;
}
.slide-right-enter,.slide-right-enter-active{
animation: bounce-left-in 400ms;
}
.slide-right-leave-active {
animation: bounce-left-out 400ms;
}
.slide-left-enter, .slide-left-enter-active{
animation: bounce-right-in 400ms;
}
.slide-left-leave-active {
animation: bounce-right-out 400ms;
}
@keyframes bounce-right-in {
  0% {
  transform: translate3d(100%, 0, 0);
  }
  100% {
  transform: translate3d(0px, 0, 0);
  }
}
@keyframes bounce-right-out {
  0% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(-100%, 0, 0);
  }
}
@keyframes bounce-left-in {
  0% {
  transform: translate3d(-100%, 0, 0);
  }
  100% {
  transform: translate3d(0px, 0, 0);
  }
}
@keyframes bounce-left-out {
  0% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(100%, 0, 0);
  }
}
.Router {
     position: absolute;
     width: 100%;
}
html,body{
  width: 100%;
  overflow:hidden;
}
</style>
